import React, { useState } from 'react';

import { Checkbox, FormControlLabel, Link } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

import GridPagination from '~/components/Common/Elements/GridPagination';

import { useGetChatStats } from '~/hooks/apis/support/useChatStats';

import { formatSeconds } from '~/services/TimeService';

const COLUMNS: Array<GridColDef> = [
  {
    field: 'chatId',
    headerName: 'Chat Id',
    flex: 1,
    sortable: false,
    renderCell: (params) => (
      <Link target="_blank" href={`/support-assistant/chats-history?chat=${params.value}`}>
        {params.value}
      </Link>
    ),
    display: 'flex',
  },
  {
    field: 'timeToAgentResponse',
    headerName: 'Agent response time',
    width: 300,
    sortable: false,
    renderCell: (params) => formatSeconds(params.value),
    display: 'flex',
  },
  {
    field: 'totalAgentChatTime',
    headerName: 'Total time w/ agent',
    width: 300,
    sortable: false,
    renderCell: (params) => formatSeconds(params.value),
    display: 'flex',
  },
  {
    field: 'totalChatTime',
    headerName: 'Total chat time',
    width: 300,
    sortable: false,
    renderCell: (params) => formatSeconds(params.value),
    display: 'flex',
  },
  {
    field: 'createdAt',
    headerName: 'Chat Created',
    width: 300,
    sortable: false,
    renderCell: (params) => params.value,
    display: 'flex',
  },
];

const SIZE_PER_PAGE = 25;

export function ChatStats() {
  const [page, setPage] = useState(0);
  const [agentChatsOnly, setAgentChatsOnly] = useState(false);
  const [hasMessagesOnly, setHasMessagesOnly] = useState(true);
  const [v2AssistantOnly, setV2AssistantOnly] = useState(false);

  const { data, isLoading } = useGetChatStats({
    filters: {
      agentChatsOnly,
      hasMessagesOnly,
      assistantVersion: v2AssistantOnly ? ('V2' as const) : undefined,
      offset: page * SIZE_PER_PAGE,
      limit: SIZE_PER_PAGE,
    },
  });

  return (
    <>
      <FormControlLabel
        control={<Checkbox checked={agentChatsOnly} onChange={(event) => setAgentChatsOnly(event.target.checked)} />}
        label="Agent chats only"
      />
      <FormControlLabel
        control={<Checkbox checked={hasMessagesOnly} onChange={(event) => setHasMessagesOnly(event.target.checked)} />}
        label="Hide Empty Chats"
      />
      <FormControlLabel
        control={<Checkbox checked={v2AssistantOnly} onChange={(event) => setV2AssistantOnly(event.target.checked)} />}
        label="V2 assistant only"
      />
      <DataGrid
        autoHeight
        columns={COLUMNS}
        density="compact"
        disableRowSelectionOnClick
        getRowHeight={() => 'auto'}
        getRowId={(row) => row.chatId}
        loading={isLoading}
        onPaginationModelChange={({ page }) => setPage(page)}
        pageSizeOptions={[100]}
        pagination
        paginationMode="server"
        paginationModel={{ page: page, pageSize: SIZE_PER_PAGE }}
        rowCount={data?.total ?? 0}
        rows={data?.chats ?? []}
        slots={{ pagination: GridPagination }}
      />
    </>
  );
}
